export const ENS_TLDS = [
  '.eth',
  '.box',
  '.base.eth',
  '.uni.eth',
  '.yodl.eth',
  '.justaname.id',
  '.cb.id',
];
